import {proposalrequest} from '@mep/pae-commons';
import {Checkbox, Form} from 'antd';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, {memo, useCallback, useEffect, useMemo, useState} from 'react';
import {useTranslation} from 'react-i18next';

import RepresentativeAval from '@/modules/authentication/pages/SignUp/components/RepresentativeAval';
import {validations} from '@/utils/fields';

const {STATE_MIPYME, CNA, ORGANIZATION_PMS} = proposalrequest;

const ProposalIsSoleOwner = ({
  value, onChange, form, skipRequired, ...rest
}) => {
  const {t} = useTranslation(['authentication', 'proposalRequest']);
  let [checked, setChecked] = useState(!!value);
  //
  const data = form.getFieldsValue();
  const isStatePyme = [STATE_MIPYME, ORGANIZATION_PMS].includes(data?.subjectType);
  const isCNA = [CNA].includes(data?.subjectType);
  //
  useEffect(() => {
    setChecked(!!value);
  }, [value]);

  const onActiveChange = useCallback((e) => {
    setChecked(e?.target?.checked);
    if (e?.target?.checked) {
      form.setFieldsValue({...data, isRepresentative: {active: false, file: null}});
    }
    onChange && onChange(e?.target?.checked);
  }, [data, form, onChange]);

  const representativeValidations = useMemo(() => {
    const elements = [{required: !checked}];
    if (!isStatePyme) elements.push(validations.mustBeCheck('authentication:signup.isRepresentative.verification', (!checked && isStatePyme)));
    return elements;
  }, [checked, isStatePyme]);

  return <div {...rest}>
    {!isCNA && <Checkbox
      checked={checked}
      className={classNames('mx-0 mt-4')}
      size={'large'}
      onChange={onActiveChange}
    >
      {t('signup.isSoleOwner.label', {type: t(`types.${data.subjectType || CNA}`)})}
    </Checkbox>}
    {!checked && <Form.Item
      className={'mt-4'}
      name="isRepresentative"
      rules={representativeValidations}
      required={!skipRequired && !checked}>
      <RepresentativeAval
        translate={'authentication'}
        label={isStatePyme ? 'signup.stateBossCheck' : 'signup.isRepresentative.label'}
        useUpload={!isStatePyme}
      />
    </Form.Item>}
  </div>;
};

ProposalIsSoleOwner.propTypes = {
  value: PropTypes.bool, skipRequired: PropTypes.bool, onChange: PropTypes.func, form: PropTypes.any,
};

ProposalIsSoleOwner.defaultProps = {};

export default memo(ProposalIsSoleOwner);

export const renderProposalIsSoleOwner = ({form}) => {
  let {isSoleOwner, isRepresentative} = form.getFieldsValue();

  return (<Form.Item
    className={'mt-4'}
    name="isSoleOwner"
    noStyle={!isSoleOwner}
    dependencies={['subjectType']}
    initialValue={isRepresentative?.active || false}>
    <ProposalIsSoleOwner form={form}/>
  </Form.Item>);
};
